


































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CallPhone from "@/pages/showDetail/CallPhone.vue";
import CONFIG from "@/common/config";
import { Grade, Gender } from "@/common/interface";
import { formatMoney } from "@/common/utils/format";

@Component({
  components: {
    "call-phone": CallPhone
  }
})
export default class GachaTypeList extends Vue {
  @Prop({ required: true }) dataList!: Array<object>;
  @Prop({ required: true }) showDetail!: any;
  @Prop({ required: true }) totalCount!: string;
  @Prop({ required: true }) gradeArr!: Grade[];
  @Prop({ required: true }) genderArr!: Gender[];
  hasPaid: boolean = true;
  formatMoney: Function = formatMoney;
  grade: string = "";
  gender: string = "";

  get needPay(): object {
    return this.showDetail.needPay;
  }

  get payAmount(): number {
    return formatMoney(this.showDetail.payAmount, 100, true);
  }

  get additionalInfo(): Array<string> {
    let additionalInfo: any = [];
    this.dataList.forEach((item: any) => {
      item.additionalInfo
        ? additionalInfo.push(JSON.parse(item.additionalInfo))
        : additionalInfo.push({});
    });
    return additionalInfo;
  }

  changeGradeArr(value: number) {
    if (!value) return null;
    let grade = this.gradeArr.find((item: Grade) => {
      return item.value == value;
    });
    return grade ? grade.label : undefined;
  }

  changeGenderArr(value: number) {
    if (!value) return null;
    let gender = this.genderArr.find((item: Gender) => {
      return item.value == value;
    });
    return gender ? gender.label : undefined;
  }

  handleChangeTab(hasPaid: boolean = true) {
    this.hasPaid = hasPaid;
    // 1: 已支付 2: 未支付
    this.$emit("refresh", { hasApply: hasPaid });
  }

  handleToWithdraw() {
    const env: string = process.env.VUE_APP_DEPLOY_ENV as string;
    const hash: string = window.location.hash.split("?")[1];
    const tempStr: string =
      (CONFIG.appShowUrl as any)[env] + "hybird/index.html#/pay/wallet?" + hash;
    window.location.replace(tempStr);
  }
}
